<div *ngIf="infoApprenant" class="class-margin">
  <div uk-grid *ngIf="target === 'caces'">
    <div class="uk-width-3-4">
      Autorisation de conduite identique au CACES® &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Non
      <kendo-switch name="switch-caces" [(ngModel)]="infoApprenant.habilitation.identique"></kendo-switch>
      Oui
    </div>
    <div class="uk-width-1-4" *ngIf="!infoApprenant.habilitation.identique">
      <select class="uk-select" id="form-horizontal-select">
        <option>CACES</option>
        <option>Autorisation de conduite</option>
      </select>
    </div>  
  </div>


<div uk-grid>
  <div class="uk-width-2-3">
    <h5 *ngIf="target === 'caces'">TEST THEORIQUE CACES®</h5>
    <h5 *ngIf="target === 'autorisationConduite'">
      EVALUATION THEORIQUE AUTORISATION DE CONDUITE
    </h5>
  </div>
</div>
<div class="uk-width-1-2">
  <kendo-label text="Date">
    <kendo-datepicker
      [format]="'dd/MM/yyyy'"
      [(ngModel)]="habilitaionApprenant.theorie.date"
      class="dateAppJust"
    ></kendo-datepicker>
  </kendo-label>
</div>
<div class="uk-width-1-1">
  <div class="uk-card uk-card-default">
    <div class="uk-card-header uk-padding-small uk-background-muted">
      <div class="uk-width-expand">
        <h3 class="uk-card-title uk-margin-remove-bottom uk-text-meta uk-text-uppercase uk-text-muted">
          Note(s) théorique(s)
        </h3>
      </div>
    </div>
    <div class="uk-card-body uk-padding-remove">
      <table class="uk-table uk-table-small uk-table-divider">
        <thead>
          <tr>
            <th>{{ 'libellé' | uppercase }}</th>
            <th>{{ 'note' | uppercase }}</th>
            <th>{{ 'echec a un theme éliminatoire' | uppercase }}</th>
            <th>{{ 'statut' | uppercase }}</th>
            <th width="10%"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let theo of habilitaionApprenant.theorie.evaluations; let i = index">
            <td>{{ getNote('libelle', theo.note) }}</td>
            <td>
              <kendo-numerictextbox kendoTextBox [(ngModel)]="theo.valeur"> </kendo-numerictextbox>
            </td>
            <td>
              {{ getNote('theme_eliminatoire', theo.note) === true ? 'oui' : 'Non' }}<br />
              {{ getNote('seuil_reussite', theo.note) || '-' }} / 100
            </td>
            <td>
              <kendo-dropdownlist
                [data]="config.statuts.dataSource"
                [textField]="'libelle'"
                [valueField]="'code'"
                [valuePrimitive]="true"
                [(ngModel)]="theo.statut"
                class="input-border"
              >
              </kendo-dropdownlist>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<div class="uk-margin">
  <div class="uk-form-controls">
    <kendo-dropdownlist
      [data]="config.resultats.dataSource"
      [textField]="'libelle'"
      [valueField]="'code'"
      [valuePrimitive]="true"
      [(ngModel)]="habilitaionApprenant.theorie.resultat"
    >
    </kendo-dropdownlist>
  </div>
</div>
<!-- Evaluations pratiques -->
<h5>TEST PRATIQUE {{ target === 'caces' ? 'CACES®' : 'AUTORISATION DE CONDUITE' }}</h5>
<div class="uk-width-1-1">
  <div class="uk-card uk-card-default">
    <div class="uk-card-header uk-padding-small uk-background-muted">
      <div class="uk-width-expand">
        <h3 class="uk-card-title uk-margin-remove-bottom uk-text-meta uk-text-uppercase uk-text-muted">
          Note(s) Pratique(s)
        </h3>
      </div>
    </div>
    <div class="uk-card-body uk-padding-remove">
      <table class="uk-table uk-table-small uk-table-divider">
        <thead>
          <tr>
            <th class="uk-width-1-5">{{ 'libellé' | uppercase }}</th>
            <th class="uk-width-1-5">{{ 'certificat' | uppercase }}</th>
            <th class="uk-width-1-5">{{ 'expiration' | uppercase }}</th>
            <th class="uk-width-1-5">{{ 'resultat' | uppercase }}</th>
            <th></th>
          </tr>
        </thead>
      </table>
      <div *ngFor="let categorie of habilitaionApprenant.pratique | keyvalue" uk-accordion>
        <div>
          <a class="uk-accordion-title" href="#">Catégorie {{ getCategorie(categorie.key) }}</a>
          <div class="uk-accordion-content">
            <div *ngFor="let eval of categorie.value['evaluations']" class="uk-grid">
              <div class="uk-width-1-5">{{ getNote('libelle', eval.note) }}</div>
              <div class="uk-width-1-5">{{ categorie.value['certificat'] }}</div>
              <div class="uk-width-1-5">
                <span *ngIf="isDateValid(categorie.value['dateExpiration'])">{{
                  categorie.value['dateExpiration'] | date: 'dd/MM/yyyy'
                }}</span>
              </div>
              <div class="uk-width-1-5">{{ getResultat(categorie.value['resultat']) }}</div>
            </div>

            <div style="float: right;">
              <button
                kendoButton
                class="colored-text primary-background edit-cat-btn"
                [primary]="true"
                (click)="open(categorie)"
              >
                <span class="small material-icons ">edit</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- popup d'édition des évaluations pratiques -->
<div>
  <div class="valid-wrapper">
    <button kendoButton class="k-button k-primary valid-btn" (click)="save()">SAUVEGARDER</button>
  </div>
  <kendo-dialog
    title="Edition d'une catégorie"
    [minWidth]="250"
    [width]="1000"
    [draggable]="true"
    *ngIf="opened"
    (close)="closePopup()"
  >
    <ags-popup-habilitation-caces-ac
      [config]="config"
      [infocategorie]="infoCategorie"
      [infohabilitation]="infoHabilitation"
      (close)="callbackSave($event)"
    >
    </ags-popup-habilitation-caces-ac>
  </kendo-dialog>
</div>
</div>